import { Html } from '@react-three/drei';
import { ZONES } from '../data/zones';

function ZoneRing({ zone }) {
  return (
    <group position={[zone.center[0], 0, zone.center[1]]}>
      {/* Glowing ring */}
      <mesh rotation-x={-Math.PI / 2} position-y={0.01}>
        <torusGeometry args={[zone.radius, 0.05, 6, 64]} />
        <meshBasicMaterial color={zone.color} transparent opacity={0.35} />
      </mesh>

      {/* Filled circle */}
      <mesh rotation-x={-Math.PI / 2} position-y={0.005}>
        <circleGeometry args={[zone.radius - 0.3, 64]} />
        <meshBasicMaterial color={zone.color} transparent opacity={0.04} />
      </mesh>

      {/* Label */}
      <Html
        position={[0, 0.1, 0]}
        center
        sprite
        occlude={false}
        zIndexRange={[0, 0]}
        style={{
          fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif",
          fontSize: '10px',
          color: zone.color,
          letterSpacing: '0.1em',
          pointerEvents: 'none',
          opacity: 0.7,
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          userSelect: 'none',
        }}
      >
        {zone.icon} {zone.name}
      </Html>
    </group>
  );
}

export default function ZoneFloor() {
  return (
    <group>
      {/* Floor */}
      <mesh rotation-x={-Math.PI / 2} receiveShadow>
        <circleGeometry args={[22, 64]} />
        <meshStandardMaterial color="#0d1117" roughness={1} />
      </mesh>

      {/* Zone rings */}
      {ZONES.map((zone) => (
        <ZoneRing key={zone.id} zone={zone} />
      ))}
    </group>
  );
}
